// Who is signed in, re-checked. Pure, so it runs under node --test
// (test/web/identity.test.js); SessionProvider.jsx does the GET /api/me and acts on it.
//
// WHY THIS EXISTS. Signing in again regenerates the session and its CSRF token
// (src/routes/auth.js), and on a shared desk the person who signed in may not be the one
// this browser tab was loaded for: every other open tab keeps the old page and, once its
// requests carry the new session cookie, is acting as the next agent. The tab may still
// be showing the previous person's draft. So on `403 CSRF_TOKEN_INVALID`, and when a tab
// regains focus, the client re-reads GET /api/me and asks this question: a change reloads
// the page clean; only a confirmed same person keeps it
// (docs/superpowers/specs/2026-10-13-multi-ticket-drafts-design.md, "A different person
// signs in on a shared desk").

/**
 * @param {string|number|null|undefined} previousUserId  The id this tab was loaded as.
 * @param {object|null|undefined} me                      A GET /api/me answer.
 * @returns {boolean} false only when both ids are present and name the same user. Ids are
 *   compared as strings (`users.id` arrives as a string, and 7 and "7" are one user).
 *   Anything that cannot be confirmed as the same user is a change, because the cost of a
 *   needless reload is a page load and the cost of a missed change is one agent's draft on
 *   another agent's screen.
 */
export function identityChanged(previousUserId, me) {
  const before = previousUserId == null ? '' : String(previousUserId);
  const now = me?.id == null ? '' : String(me.id);
  if (before === '' || now === '') return true;
  return before !== now;
}
